import { render, staticRenderFns } from "./CalendeskWarningMessage.vue?vue&type=template&id=08ac36dc"
import script from "./CalendeskWarningMessage.vue?vue&type=script&lang=ts"
export * from "./CalendeskWarningMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports